export enum ApplyIndexActionType {
  ClearState = 'CLEAR STATE',
  UpdateValue = 'UPDATE VALUE',
  RemoveKey = 'REMOVE KEY'
}
